/* src/app/core/pages/forbidden/forbidden.component.scss */
/*# sourceMappingURL=forbidden.component.css.map */
